import { render, staticRenderFns } from "./ExtendedTables.vue?vue&type=template&id=89534ae2&scoped=true"
import script from "./ExtendedTables.vue?vue&type=script&lang=js"
export * from "./ExtendedTables.vue?vue&type=script&lang=js"
import style0 from "./ExtendedTables.vue?vue&type=style&index=0&id=89534ae2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89534ae2",
  null
  
)

export default component.exports